import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${themeColor('element.disabledBackground', { dark: 'element.secondary' })};
  border-radius: 24px;
  padding: 8px 12px;
  min-width: 220px;
  max-width: 280px;
`;

export const PlayBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: ${themeColor('brand.primary')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  color: ${themeColor('brand.overPrimary')};
  padding: 0;

  &:hover {
    opacity: 0.85;
  }
`;

export const ProgressBar = styled.div`
  flex: 1;
  height: 4px;
  background: ${themeColor('divider.primary')};
  border-radius: 2px;
  cursor: pointer;
  position: relative;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: ${themeColor('brand.primary')};
  border-radius: 2px;
  transition: width 0.1s linear;
  pointer-events: none;
`;

export const TimeLabel = styled.span`
  font-size: 11px;
  color: ${themeColor('element.secondary')};
  white-space: nowrap;
  min-width: 36px;
`;

export const IconBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  color: ${themeColor('element.secondary')};
  flex-shrink: 0;

  &:hover {
    color: ${themeColor('element.primary')};
  }
`;

export const ErrorMessage = styled.span`
  font-size: 11px;
  color: ${themeColor('negative.primary')};
  width: 100%;
`;
